import { Wrap } from '../LoaderHomePage/Loader.styled';
import { Spiner } from './Spiner';

export const LoaderHomePage = () => {
  return (
    <Wrap>
      <Spiner />
    </Wrap>
  );
};
